module.exports = __webpack_public_path__ + "static/media/suzlonLogo.3ceff624.svg";